<template>
  <div>
    <div class="postavitev-besedila">
      <p class="navadno-besedilo">
        Dogodki so razvrščeni po padajočem datumu nastanka (najnovejši pri vrhu).
      </p>
    </div>
    <div class="tabela">
      <span v-if="prikazTabele === '1'">
        <div style="width: 100%;" v-loading="nalaganjeTabele">
          <el-table :data="seznamPodatkov" @sort-change="SortAndSplice" stripe :default-sort = "{prop: 'datum.date', order: 'descending'}">
            <el-table-column prop="formatDatuma"
                             sortable
                             label="Datum">
            </el-table-column>
            <el-table-column prop="ip"
                             label="IP">
            </el-table-column>
            <el-table-column prop="opis"
                             label="Opis">
            </el-table-column>
            <el-table-column label="Dodatno" prop="additionalTxt">
              <template slot-scope="scope">
                <template v-if="isJsonData(scope.row.additionalTxt)">
                  <div
                    v-for="(item, index) in getParsedJsonRows(scope.row.additionalTxt, 0)"
                    style="border-bottom: 1px solid lightgrey; display: flex;"
                    :key="`jsonRow-${index}`"
                  >
                    <div :style="`padding-left: ${item.depth * 15}px; font-weight: bold;`">{{item.key}}</div>
                    <div style="flex: auto; text-align: right;">{{item.value}}</div>
                  </div>
                </template>
                <template v-else>{{scope.row.additionalTxt}}</template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </span>
      <span v-else>
        <el-table
          :data="seznamPodatkov"
        >
          <el-table-column>
            <template slot-scope="props">
              <p>
                <span>
                  <b>
                    Datum:
                  </b>
                </span>
                {{ props.row.formatDatuma }}
              </p>
              <p>
                <span>
                  <b>
                    IP:
                  </b>
                </span>
                {{ props.row.ip }}
              </p>
              <p>
                <span style="padding-bottom: -20px;">
                  <b>
                    Opis:
                  </b>
                </span>
                {{ props.row.opis }}
              </p>
              <p>
                <span>
                  <b>
                    Dodatno:
                  </b>
                </span>
                <template v-if="isJsonData(props.row.additionalTxt)">
                  <div
                          v-for="(item, index) in getParsedJsonRows(props.row.additionalTxt, 0)"
                          style="border-bottom: 1px solid lightgrey; display: flex;"
                          :key="`jsonRow-${index}`"
                  >
                    <div :style="`padding-left: ${item.depth * 15}px;`">{{item.key}}</div>
                    <div style="flex: auto; text-align: right;">{{item.value}}</div>
                  </div>
                </template>
                <template v-else>{{props.row.additionalTxt}}</template>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </span>
      <div class="text-center" style="cursor: pointer; padding-top: 20px">
        <el-pagination
          :hide-on-single-page="true"
          @current-change="PrikaziStran"
          :page-size="1"
          layout="prev, pager, next"
          :total="dolzinaSeznamaZgodovinaDostopov"
          small>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import Vue from 'vue'
import {
  Table, TableColumn, Input, Button, Form, FormItem, Option, Collapse, CollapseItem, Select, Loading,
  Pagination
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {FormatDatuma} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'
Vue.use(Pagination)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Loading)
export default {
  name: 'ZgodovinaDostopov',
  mixins: [PrikazVsebine, FormatDatuma],
  data () {
    return {
      email: '',
      trenutnoGeslo: '',
      novoGeslo: '',
      potrjenoGeslo: '',
      clientAgent: null,
      uporabnikoviPodatki: [],
      nalaganjeTabele: false,
      seznamPodatkov: [],
      dolzinaSeznamaZgodovinaDostopov: null,
      nalaganjeNovegaGesla: false,
      formaOrientacija: 'left',
      prikazeIkonoPonoviteGeslo: true,
      prikazeIkonoNovoGeslo: true,
      mejnaSirina: 500,
      izbranIdStranka: '',
      seznamPrikljuckov: ''
    }
  },
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Pagination.name]: Pagination
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetPrikljuckiDovoljenja()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    isJsonData (data) {
      return data.slice(0, 1) === '{'
    },
    getParsedJsonRows (json, depth) {
      if (depth === 10) {
        return []
      }
      let out = []
      let obj = JSON.parse(json)
      if (typeof obj === 'object') {
        let isBaseArray = Array.isArray(obj)
        let keys = Object.keys(obj)
        for (let key of keys) {
          if (typeof obj[key] === 'object' && !Array.isArray(obj[key]) && obj[key] !== null) {
            out.push({
              key: isBaseArray ? (Number.parseInt(key) + 1) : key,
              value: null,
              depth: depth
            })
            let resp = this.getParsedJsonRows(JSON.stringify({...obj[key]}), depth + 1)
            out = [...out, ...resp]
          } else {
            if (Array.isArray(obj[key])) {
              if (obj[key].length === 0) {
                out.push({
                  key: key,
                  value: 'Ni podatka',
                  depth: depth
                })
              } else {
                if (typeof obj[key][0] === 'object' && obj[key] !== null) {
                  out.push({
                    key: key,
                    value: null,
                    depth: depth
                  })
                  let resp = this.getParsedJsonRows(JSON.stringify([...obj[key]]), depth + 1)
                  out = [...out, ...resp]
                } else {
                  out.push({
                    key: key,
                    value: obj[key].join(', '),
                    depth: depth
                  })
                }
              }
            } else {
              if (['access_token'].indexOf(key) === -1) {
                out.push({
                  key: key,
                  value: obj[key] !== null ? obj[key] : 'Ni podatka',
                  depth: depth
                })
              }
            }
          }
        }
      }

      return out
    },
    GetPrikljuckiDovoljenja () {
      let param = ['permissionId=NAROCNINE']
      this.clientAgent.postWsRequest(
        this,
        'permissions/havePermission',
        param,
        null,
        'SetPrikljuckiDovoljenja',
        '')
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckov = podatki.permission.additionalData
      if (this.seznamPrikljuckov !== null) {
        if (this.seznamPrikljuckov.length > 0) {
          this.izbranIdStranka = this.seznamPrikljuckov[0].id_stranka
          this.GetUserData()
        }
      }
    },
    GetUserData () {
      this.nalaganjeTabele = true
      let param = []
      param.push('idStranka=' + this.izbranIdStranka)
      this.clientAgent.postWsRequest(
        this,
        'logs/info?',
        param,
        null,
        'SetUserData',
        'ErrUserData')
    },
    SetUserData (podatki) {
      for (let i = 0; i < podatki.data.length; i++) {
        let formatDatuma = this.PoenotenIzgledDatuma(podatki.data[i].datum.date)
        Vue.set(podatki.data[i], 'formatDatuma', formatDatuma)
        this.uporabnikoviPodatki.push(podatki.data[i])
      }
      this.SortAndSplice(null)
      this.nalaganjeTabele = false
      this.PrikaziStran(1)
    },
    PrikaziStran (stran) {
      let tmpData = []
      const chunk = 8
      for (let i = 0; i < this.uporabnikoviPodatki.length; i += chunk) {
        tmpData.push(this.uporabnikoviPodatki.slice(i, i + chunk))
      }
      this.dolzinaSeznamaZgodovinaDostopov = tmpData.length
      if (typeof tmpData[stran - 1] !== 'undefined') {
        this.seznamPodatkov = tmpData[stran - 1]
      } else {
        this.seznamPodatkov = []
      }
    },
    ErrUserData (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    SortAndSplice (sortParams = null) {
      if (sortParams === null || sortParams.order === 'descending') {
        this.uporabnikoviPodatki.sort(function (a, b) { return new Date(b.datum.date) - new Date(a.datum.date) })
      } else {
        this.uporabnikoviPodatki.sort(function (a, b) { return new Date(a.datum.date) - new Date(b.datum.date) })
      }
      this.PrikaziStran(1)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/moj_profil/varnost.css">

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/Varnost/ZgodovinaDostopov.vue